import { TemplateProps } from '../../types';
import Header from './Header';
import Hero from './Hero';
import Services from './Services';
import Footer from './Footer';
import CallbackModal from './CallbackModal';
import * as S from './styles';

function Moderno({
  carteira,
  contatos,
  telValue,
  mensagem,
  callbackAberto,
  onSelectContato,
  onChangeTel,
  onSubmitTel,
  onFecharCallback,
}: TemplateProps) {
  const logoAlt = `Logotipo ${carteira.carteiraCrmText ?? 'Bellinati Perez'}`;

  return (
    <S.Page>
      <Header logoUrl={carteira.urlLogoLandingPage} logoAlt={logoAlt} />

      <S.Main>
        <Hero titulo={carteira.titulo} subTitulo={carteira.subTitulo} />
        <Services contatos={contatos} onSelect={onSelectContato} />
      </S.Main>

      <Footer logoUrl={carteira.urlLogoClienteBase64 || carteira.urlLogo} logoAlt={logoAlt} />

      <CallbackModal
        aberto={callbackAberto}
        telValue={telValue}
        mensagem={mensagem}
        onChangeTel={onChangeTel}
        onSubmitTel={onSubmitTel}
        onFechar={onFecharCallback}
      />
    </S.Page>
  );
}

export default Moderno;
